import immutable from 'seamless-immutable';
import { createReducer, completeReducer, completeState, onReadValue } from 'redux-recompose';

import { actions } from './actions';

const defaultState = completeState({
  product: {}
});

const reducerDescription = {
  primaryActions: [actions.GET_PRODUCT_BY_ID],
  override: {
    [actions.CLEAN_PRODUCT]: onReadValue()
  }
};

const reducer = createReducer(immutable(defaultState), completeReducer(reducerDescription));
export default reducer;
